<template>
  <div>
    <div class="contents xpointlist">
      <div class="filter-box-2 d-flex justify-content-end">
        <div>
          <select aria-label="" v-model="searchData.xpoint_type">
                <option value="0" selected>
                  {{ $t("filter.common.total") }}
                </option>
                <option value="1">{{ $t("text.admin.regular") }}</option>
                <option value="2">{{ $t("text.admin.major") }}</option>
                <option value="3">{{ $t("text.admin.novelty") }}</option>
           </select>
        </div>
      </div>
      <table class="table board toggle-xxl">
        <thead>
          <tr>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-xxl-table-cell">
              {{ $t("title.admin.grade") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.type") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.admin.range1") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.admin.range2") }}
            </th>
            <th class="col-auto d-xxl-table-cell">
              {{ $t("title.common.standard_point") }}
            </th>
            <th class="col-auto d-xxl-table-cell">
              {{ $t("title.common.oom_point") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.date") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.control") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="totalCnt > 0">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-xxl-table-cell w-1">{{ item.no }}</td>
              <td class="col-auto d-xxl-table-cell">
                {{ item.grade }}
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                {{
                  item.xpoint_type == 1
                    ? $t("text.admin.regular")
                    : item.xpoint_type == 2
                    ? $t("text.admin.major")
                    : $t("text.admin.novelty")
                }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.range1 }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.range2 }}
              </td>
              <td class="col-auto d-xxl-table-cell text-point-sp">
                {{ item.standard_point | comma | suffix("P") }}
              </td>
              <td class="col-auto d-xxl-table-cell text-point-op">
                {{ item.oom_point | comma | suffix("P") }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell text-date">
                {{ item.timezone_regdate | dateformat }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell w-1">
                <button
                  type="button"
                  class="btn btn-secondary btn-xs mx-auto"
                  @click="
                    $router.push({
                      name: 'XpointEdit',
                      params: { xpoint_pk: item.xpoint_pk },
                    })
                  "
                >
                  {{ $t("button.common.edit") }}
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-xs text-white mx-auto"
                  @click="delete_xpoint(item.xpoint_pk)"
                >
                  {{ $t("button.common.delete") }}
                </button>
              </td>
              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="9">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.common.type") }}</div>
                    <div class="col-8">
                      {{
                        item.xpoint_type == 1
                          ? $t("text.admin.regular")
                          : item.xpoint_type == 2
                          ? $t("text.admin.major")
                          : $t("text.admin.novelty")
                      }}                      
                    </div>
                  </div>                  
                  <div class="row">
                    <div class="col-4">{{ $t("title.admin.range1") }}</div>
                    <div class="col-8">{{ item.range1 }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.admin.range2") }}</div>
                    <div class="col-8">{{ item.range2 }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.date") }}
                    </div>
                    <div class="col-8 text-date">
                      {{ item.timezone_regdate | dateformat }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.control") }}</div>
                    <div class="col-8">
                      <div class="d-flex flex-column align-items-start">
                        <button
                          type="button"
                          class="btn btn-secondary btn-xs"
                          @click="
                            $router.push({
                              name: 'XpointEdit',
                              params: { xpoint_pk: item.xpoint_pk },
                            })
                          "
                        >
                          {{ $t("button.common.edit") }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-danger btn-xs text-white"
                          @click="delete_xpoint(item.xpoint_pk)"
                        >
                          {{ $t("button.common.delete") }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="pageTotal"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="pageTotal > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="primary"
          :aria-label="$t('button.common.write')"
          @click="$router.push({ name: 'XpointWrite' })"
          >{{ $t("button.common.write") }}</b-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/manager";

export default {
  name: "XpointList",
  data() {
    return {
      searchData: {
        xpoint_type:
          this.$route.query.xpoint_type ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].xpoint_type) ||
          "0",
        pageno:
          this.$route.query.pageno || this.$store.state.searchData.pageno || 1,
      },
      pageTotal: 1,
      totalCnt: 0,
      dataYn: true,
      rows: 9999,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.xpoint_type": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.pageno": function () {
      this.getList();
    },
  },

  created() {
    this.getList();
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
    },
    getList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_xpointlist(this.searchData, (flag, data) => {
        this.totalCnt = data.listcnt;
        this.pageTotal = Math.ceil(data.listcnt / this.rows);
        this.items = data.list;
        if (!flag) alert(data.message);
      });
    },
    delete_xpoint(xpoint_pk) {
      if (confirm(this.$i18n.t("alert.common.want_to_delete"))) {
        ax.delete_xpoint(xpoint_pk, (flag, data) => {
          if (flag) {
            alert(data.message);
            this.getList();
          } else {
            alert(data.message);
          }
        });
      }
    },
    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>